import { createAsyncAction } from "typesafe-actions";
import { deleteResourceApi, downloadResourceApi } from "./resources.api";
import {ResourceDto} from './resources.dtos'

export const resourceActions = createAsyncAction(
    'GET_RESOURCE_REQUEST',
    'GET_RESOURCE_SUCCESS',
    'GET_RESOURCE_ERROR',
  )<string, ResourceDto, string>();
  
  export const resourcesActions = createAsyncAction(
    'GET_RESOURCES_REQUEST',
    'GET_RESOURCES_SUCCESS',
    'GET_RESOURCES_ERROR',
  )<string, ResourceDto[], string>();
  
  export const updateResourceActions = createAsyncAction(
    'UPDATE_RESOURCE_REQUEST',
    'UPDATE_RESOURCE_SUCCESS',
    'UPDATE_RESOURCE_ERROR',
  )<ResourceDto, ResourceDto, string>();
  
  export const createResourceActions = createAsyncAction(
    'CREATE_RESOURCE_REQUEST',
    'CREATE_RESOURCE_SUCCESS',
    'CREATE_RESOURCE_ERROR',
  )<ResourceDto, ResourceDto, string>();

  
  export const deleteResourceAction = (resource: ResourceDto) => deleteResourceApi(resource);

  export const downloadResourceAction = (uploadName: string, mimeType: string, fileName: string) => downloadResourceApi(uploadName, mimeType, fileName);